<template>
	<Form ref="formValidate" :model="formValidate"  :label-width="110":label-colon="true">
		<Row>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="投放渠道" prop="appStoreId" >
				<Select v-model="formValidate.appStoreId" clearable >
					<Option v-for="item in appStores" :value="item.id" :key="item.id">{{item.storeName}}</Option>
				</Select>
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="广告名称" >
				<Input v-model="formValidate.advertName" clearable/>
			</FormItem>
			</Col>
			
			<Col :md="6" :sm="12" :xs="24">
			<FormItem>
				<Button type="primary" @click="formSubmit" icon="md-search" style="margin: 0 8px 16px 16px;">查询</Button>
				<Button type="default" @click="formReset" style="margin: 0 0 16px 0;">重置</Button>
			</FormItem>
			</Col>
		</Row>
	</Form>
</template>
<script>
	import api from '../../api'
	import { mapGetters } from 'vuex'
	import { STATISTICS_START_TIME, LINK_TYPES, ADVERT_TYPES } from '../../config/constants'

	export default {
		name: 'QueryCondition',
		props: {
			showPageStatus: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				appStores: [],
				linkTypes: LINK_TYPES,
				advetTypes: ADVERT_TYPES,
				formValidate: {
					appStoreId: '',
					advertName:'',
				}
			}
		},
		computed: {
			...mapGetters('statistics', ['accountGroup', 'pageStatus'])
		},
		mounted() {
			this.getAllAppStore()
		},
		methods: {
			getAllAppStore() {
				api.statistics
					.getAllUsedStores()
					.then(res => {
						this.appStores = res.data
					})
			},
			formSubmit() {
				this.$emit('query', this.getFormData())
			},
			formReset() {
				this.$refs['formValidate'].resetFields()
				this.formValidate = {
					dateRange: [],
				}
				this.formSubmit()
			},
			getFormData() {
				const formData = { ...this.formValidate }
				return formData
			}
		}
	}
</script>
